// extracted by mini-css-extract-plugin
module.exports = {"CollapseButton__collapse-button__1n5nh":"CollapseButton__collapse-button__1n5nh","CollapseButton__button__2FTUd":"CollapseButton__button__2FTUd"};